import { createSlice, combineReducers } from "@reduxjs/toolkit";
import { cashflowForecastingReducers } from "./cashflow-forecasting";
const initialState = {
    selectedSection: "SystemAdministration",
    selectedTabUid: {}
};
const slice = createSlice({
    initialState,
    name: "commonAdministrationReducers",
    reducers: {
        setSelectedTabUid: (state, action) => {
            state.selectedTabUid[action.payload.page] = action.payload.tabUid;
        }
    }
});
export const administrationReducers = combineReducers({
    cashflowForecastingState: cashflowForecastingReducers,
    commonState: slice.reducer
});
export const commonAdministrationReducers = slice.reducer;
export const { setSelectedTabUid } = slice.actions;
